<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items :items="menuItems" />
  </div>
</template>

<script>
import navMenuItems from '@/navigation/horizontal'
import { computed } from '@vue/composition-api'
import store from '@/store'
import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'

export default {
  components: {
    HorizontalNavMenuItems,
  },
  setup() {
    const menuItems = computed(() => navMenuItems.map(item => {
      if (item.route !== 'chat') return item

      const unreadChatCount = store.getters['socket/unreadChatCount']
      return {
        ...item,
        tag: unreadChatCount > 99 ? '99+' : unreadChatCount,
        tagVariant: 'danger',
      }
    }))

    return {
      navMenuItems,
      menuItems,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
